export default "__VITE_ASSET__6dd423bb__"